<template>
  <div class="card p-4">
    <div class="col-12 d-md-flex justify-content-lg-between mb-3 clickable" @click.prevent="toggle">
      <h4><span class="badge badge-danger"><b>{{ showing ? "--":"+"}}</b></span> Informações</h4>
      <h6>Criado em {{ information.created_at }}</h6>
    </div>

    <div class="collapse show" id="collapse-info">
      <div class="row">
        <div class="col-12 col-md-4 mb-3">
          <label>Nome do Curso</label>
          <input
            :class="{
              'form-control form-control-sm': true,
              'is-invalid': information.errors.has('name')
            }"
            v-model="information.name"
          >
          <has-error :form="information" field="name" />
        </div>

        <div class="col-12 col-md-3 mb-3">
          <label>Valor do Curso</label>
          <div class="input-group input-group-sm">
            <span class="input-group-prepend">
              <span class="input-group-text">R$</span>
            </span>
            <input
              :disabled="information.is_free"
              :class="{
                'form-control form-control-sm': true,
                'is-invalid': information.errors.has('value')
              }"
              v-model="information.value"
              type="number"
            >
          </div>
          <has-error :form="information" field="value" />
        </div>

        <div class="col-12 col-md-3 mb-3">
          <label>Valor Promocional</label>
          <div class="input-group input-group-sm">
            <span class="input-group-prepend">
              <span class="input-group-text">R$</span>
            </span>
            <input
              :disabled="information.is_free"
              :class="{
                'form-control form-control-sm': true,
                'is-invalid': information.errors.has('value_sale')
              }"
              v-model="information.value_sale"
              type="number"
            >
          </div>
          <has-error :form="information" field="value_sale" />
        </div>

        <div class="col-12 col-md-2 mb-3">
          <label>&nbsp;</label>
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              :class="{
                'custom-control-input': true,
                'is-invalid': information.errors.has('is_free')
              }"
              v-model="information.is_free"
              id="customSwitchFree"
            >
            <label class="custom-control-label" for="customSwitchFree">Gatuito?</label>
          </div>
          <has-error :form="information" field="is_free" />
        </div>

        <div class="col-12 col-md-4 mb-3">
          <label>Carga Horária</label>
          <div class="input-group input-group-sm">
            <input
              :class="{
                'form-control form-control-sm': true,
                'is-invalid': information.errors.has('workload')
              }"
              v-model="information.workload"
              type="number"
            >
            <span class="input-group-append">
              <span class="input-group-text">Horas</span>
            </span>
          </div>
          <has-error :form="information" field="workload" />
        </div>

        <div class="col-12 col-md-8 mb-3">
          <label>Link para Carrinho de Compra</label>
          <div class="input-group input-group-sm">
            <span class="input-group-prepend">
              <span class="input-group-text">https://{{ hostname }}/carrinho/ </span>
            </span>
            <input
              :class="{
                'form-control form-control-sm': true,
                'is-invalid': information.errors.has('cart_link')
              }"
              v-model="information.cart_link"
              type="text"
            >
            <span class="input-group-append">
              <button @click="generateLink" class="input-group-text">Gerar Link</button>
            </span>
          </div>
          <has-error :form="information" field="cart_link" />
        </div>

        <div class="col-12 mb-3">
          <label>Resumo</label>
          <textarea
            :class="{
              'form-control form-control-sm': true,
              'is-invalid': information.errors.has('sumary')
            }"
            v-model="information.sumary"
          ></textarea>
          <has-error :form="information" field="sumary" />
        </div>


        <div class="col-12 mb-3">
          <label>Descrição</label>
          <textarea
          rows="9"
            :class="{
              'form-control form-control-sm': true,
              'is-invalid': information.errors.has('description')
            }"
            v-model="information.description"
          ></textarea>
          <has-error :form="information" field="description" />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label>Requerimentos</label>
          <textarea
            rows=""
            :class="{
              'form-control form-control-sm': true,
              'is-invalid': information.errors.has('requirements')
            }"
            v-model="information.requirements"
          ></textarea>
          <has-error :form="information" field="requirements" />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label>Irá Aprender</label>
          <textarea
            :class="{
              'form-control form-control-sm': true,
              'is-invalid': information.errors.has('will_learn')
            }"
            v-model="information.will_learn"
          ></textarea>
          <has-error :form="information" field="will_learn" />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label>Chave do Google Analytics</label>
          <input
            :class="{
              'form-control form-control-sm': true,
              'is-invalid': information.errors.has('analytics_id')
            }"
            v-model="information.analytics_id"
          >
          <has-error :form="information" field="analytics_id" />
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label>Chave do Facebook Pixel</label>
          <input
            :class="{
              'form-control form-control-sm': true,
              'is-invalid': information.errors.has('pixel_id')
            }"
            v-model="information.pixel_id"
          >
          <has-error :form="information" field="pixel_id" />
        </div>

        <div class="col-12 mb-3">
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              :class="{
                'custom-control-input': true,
                'is-invalid': information.errors.has('is_sellable')
              }"
              v-model="information.is_sellable"
              id="customSwitch1"
            >
            <label class="custom-control-label" for="customSwitch1">Este curso esta disponivel para venda?</label>
          </div>
          <has-error :form="information" field="is_sellable" />
        </div>

        <div class="col-12 mb-3">
          <div class="custom-control custom-switch">
            <input
              type="checkbox"
              :class="{
                'custom-control-input': true,
                'is-invalid': information.errors.has('disable_doubt')
              }"
              v-model="information.disable_doubt"
              id="customSwitch2"
            >
            <label class="custom-control-label" for="customSwitch2">Bloquear envio de dúvidas deste curso?</label>
          </div>
          <has-error :form="information" field="disable_doubt" />
        </div>

        <div class="col-12 text-right">
          <button class="btn btn-success" @click="save">Salvar Informações</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HasError } from 'vform'
import Swal from 'sweetalert2'

export default {
  props: {
    information: {
      required: true
    }
  },
  data () {
    return {
      showing: true
    }
  },
  computed: {
    hostname: function () {
      return window.location.hostname
    }
  },
  methods: {
    save: function () {
      this.information.post('/teacher/course/information')
        .then( res => {
          Swal.fire({
            icon: 'success',
            text: 'Informações atualizadas',
            title: 'Sucesso'
          })
        })
        .catch( err => {
          console.error( err )
        })
    },

    toggle: function () {
      this.showing = !this.showing
      $("#collapse-info").collapse('toggle')
    },

    generateLink: function () {
      let coupom = Math.random().toString(36).substring(2, 15) + "-" + Math.random().toString(36).substring(2, 5) + "-" + Math.random().toString(36).substring(2, 5);
      this.information.cart_link = coupom.toLowerCase();
    }
  }
}
</script>
